var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hide)?_c('div',[_c('div',{class:['crawl-wrapper', _vm.drawer ? 'crawl-wrapper--drawer-expanded' : '']},[_c('div',{ref:"seabornCreature",staticClass:"seaborn-creature"},[_vm._v("   ")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }